import { HotelsIcon } from "src/assets/Icons";
import i18n from "src/i18n";
import { formatNumber } from "src/utility";
import type { DataMap } from "../../../OrderCard/constants";
import type { OrderStatusKey } from "../../../../constants";

type HotelTransaction = {
  referenceNumber: string | null;
  confirmationNumber: string | null;
  hotelName: string | null;
  cityName: string | null;
  checkIn: string;
  checkOut: string;
  guestCount: number;
  roomCount: number;
  bookingStatus: OrderStatusKey;
  totalAmount: number;
  pointsUsed: number;
  orderDate: string;
  orderStatus: OrderStatusKey;
};

type HotelTransactionsRequest = {
  dateFrom?: string;
  dateTo?: string;
  clientId?: string;
};

const HOTEL_CARD_ICON = (
  <div className="rounded-xl bg-background-minimal p-2" aria-hidden="true">
    <HotelsIcon className="text-font-active" aria-hidden="true" />
  </div>
);

const HOTEL_CARD_DATA_MAP = {
  referenceNumber: {
    get label() {
      return i18n.t("UserHistory.ordersList.referenceNumber");
    },
  },
  cityName: {
    get label() {
      return i18n.t("UserHistory.ordersList.destinationCity");
    },
  },
  checkInOut: {
    get label() {
      return i18n.t("UserHistory.ordersList.checkInOutDates");
    },
  },
  guestCount: {
    get label() {
      return i18n.t("UserHistory.ordersList.numberOfGuests");
    },
    value: (val: number) => (val > 1 ? i18n.t("UserHistory.ordersList.guests", { count: val }) : i18n.t("UserHistory.ordersList.guest", { count: val })),
  },
  pointsUsed: {
    get label() {
      return i18n.t("UserHistory.ordersList.pointsUsed");
    },
    value: (val: number) => (
      <span className="text-font-active">{i18n.t("UserHistory.ordersList.pointsValue", { value: formatNumber(val) })}</span>
    ),
  },
  totalAmount: {
    get label() {
      return i18n.t("UserHistory.ordersList.totalAmount");
    },
    value: (val: number) => formatNumber(val),
  },
} satisfies DataMap;

export type { HotelTransaction, HotelTransactionsRequest };
export { HOTEL_CARD_ICON, HOTEL_CARD_DATA_MAP };
